import { gsap } from 'gsap';

export default class Grid {
    static init() {
        document.addEventListener('bless', () => {
			const gridWrapper = document.querySelector('.grid');
			new Grid(gridWrapper);
		});
    }

    constructor(gridWrapper) {
        this.gridWrapper  = gridWrapper;

        if (!this.gridWrapper) {
			return;
		}

        this.gridItems = [];
        this.items = [...this.gridWrapper.querySelectorAll('.grid__item')];

        this.showItems();
    }

    showItems() {
        gsap
        .timeline()
        .set(this.items, {scale: 0.7, opacity: 0}, 0)
        .to(this.items, {
            duration: 2,
            ease: 'Expo.easeOut',
            scale: 1,
            stagger: {amount: 0.6, grid: 'auto', from: 'center'}
        }, 0)
        .to(this.items, {
            duration: 3,
            ease: 'Power1.easeOut',
            opacity: 1,
            stagger: {amount: 0.6, grid: 'auto', from: 'center'}
        }, 0);
    }
}